<div>
  <span>La session en cours va être interrompu dans {{ this.count | async }} s</span>
  <div class="btn-grp">
    <button mat-stroked-button (click)="refresh()">Continuer</button>
  </div>
</div>
